import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import SubmitButton from './SubmitButton';
import QuestionButton from './QuestionButton';
import Header from './Header';

/**
 * Functional component that initializes the landing page of the form
 *
 * @param {object} props - properties for the component
 */
const FrontPage = (props) => {
    const { t } = useTranslation();

    const localProps = {
        step: props.step,
        setStep: props.setStep,
        infoText: t('infoTextFront'),
        headerText: t('3rdPartyHeader'),
        submitText: t('submitTextFront'),
        submitTooltip: t('infoTextFront'),
        submitClasses: 'btn btn-lg btn-primary button-group-link-button',
    };

    return (
        <Fragment>
            <form className="form-signin index-signin">
                <Header {...localProps} />
                <h4 className="text-align-center">{t('infoTextFrontElectricity')}</h4>
                <h4 className="text-align-center">{t('infoTextFrontPhoneEmail')}</h4>
            </form>
            <div className="col-md-offset-3 col-md-6">
                <div className="btn-group index-info-button-group">
                    <SubmitButton {...localProps} />
                    <QuestionButton {...localProps} />
                </div>
                <h6 className="text-align-center">{t('3rdPartyDisclaimer')}</h6>
            </div>
        </Fragment>
    );
};

export default FrontPage;
